import { FC } from 'react'

import { EuiCallOut, EuiSpacer } from '@elastic/eui'

interface BlueprintEditWarningProps {
  show?: boolean
}

const BlueprintEditWarning: FC<BlueprintEditWarningProps> = ({ show = false }) => {
  if (!show) return null

  return (
    <>
      <EuiCallOut title="Changes made here apply only to this AI Plan and will not update the source Blueprint." size="s" />
      <EuiSpacer size="m" />
    </>
  )
}

export default BlueprintEditWarning
